import { createContext } from 'react';
import PropTypes from 'prop-types';
import { FacetBody } from './FacetBody';

export const FacetContext = createContext({ defaultActiveKey: undefined });

export const Facet = ({ children, className, defaultActiveKey, ...props }) => {
  return (
    <div className={className} {...props}>
      <FacetContext.Provider value={{ defaultActiveKey }}>
        {children}
      </FacetContext.Provider>
    </div>
  );
};

Facet.propTypes = {
  as: PropTypes.elementType,

  activeKey: PropTypes.string,

  defaultActiveKey: PropTypes.string
};

Facet.Item = FacetBody;
